export default __webpack_public_path__ + "static/media/item_4_active.e1f0e7ed.png";